import { useAdCampaign } from '~/composables/adCampaign/adCampaign';

export default defineNuxtRouteMiddleware(to => {
	const {
		routeHasCampaignParams,
		getCampaignParamsFromRoute,
		setAdCampaign,
		hasCampaignInSession
	} = useAdCampaign();

	if (import.meta.client && !hasCampaignInSession.value) {
		const hasCampaignParams = routeHasCampaignParams(to);

		if (hasCampaignParams) {
			const campaignParams = getCampaignParamsFromRoute(to);
			setAdCampaign(toRaw(campaignParams));
		}
	}
});
